import React from "react";
import { useSelector, useStore } from "react-redux";
import { useTranslation } from "react-i18next";
import styles from "./index.module.less";

const ranges = {
  "-50": "#FF0000",
  "-46": "#FF3300",
  "-42": "#FF6600",
  "-38": "#FF9900",
  "-34": "#FFCC00",
  "-30": "#FFFF00",
  "-26": "#CCFF00",
  "-22": "#99FF00",
  "-18": "#66FF00",
  "-14": "#33FF00",
  "-10": "#00FF00",
  "-6": "#00FF33",
  "-2": "#00FF66",
  0: "#00FF7F",
  2: "#00FF99",
  6: "#00FFCC",
  10: "#00FFFF",
  14: "#00CCFF",
  18: "#0099FF",
  22: "#0066FF",
  26: "#0033FF",
  30: "#0000FF",
};

const displayLabel = (k) => {
  switch (k) {
    case "0":
    case "14":
    case "30":
    case "-26":
    case "-50":
      return k;
    default:
      return "";
  }
};

function Legend() {
  const { t } = useTranslation();
  const { select } = useStore();
  const risk = useSelector(select.layer.selectRisk);
  if (!risk) return null;
  let orderedKeys = Object.keys(ranges).sort((a, b) => a - b);

  const legends = orderedKeys.map((k) => {
    return (
      <div key={`legend-${k}`} className="item">
        <div className="color" style={{ background: `${ranges[k]}` }}></div>
        <div className="label">{displayLabel(k)}</div>
      </div>
    );
  });
  return (
    <div className={styles.legendPanel}>
      <div className="title">{t("riskLegend")}</div>
      {legends}
    </div>
  );
}

export default Legend;
